import { getBlockingCodeIssue } from '@/hooks/useIsDraftDirty';
import { useNotificationStore } from '@/stores/notificationStore';

interface HeaderCodeGuardOptions {
  includeNodeCode?: boolean;
  title?: string;
}

export const blockHeaderActionForCodeIssue = (
  options: HeaderCodeGuardOptions = {},
): boolean => {
  const issue = getBlockingCodeIssue();
  if (
    !issue ||
    (!options.includeNodeCode && issue.reason === 'node_code_unapplied')
  ) {
    return false;
  }

  useNotificationStore.getState().addNotification({
    type: 'error',
    title: options.title ?? issue.title,
    message: issue.message,
  });
  return true;
};
